import type { UseQueryResult } from '@tanstack/react-query';
import { TURN_TO_DEFAULT_LOAD_LIMIT } from '../../components/turn-to/const';
import { useBffGet } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { QuestionSortOptions } from '../../components/turn-to/types';
import type { QuestionResponse } from './model';

export const useGetTurnToQuestions = (
    productId?: string,
    limit = TURN_TO_DEFAULT_LOAD_LIMIT,
    offset = 0,
    sortOption: QuestionSortOptions = 'mostRecent',
    enabled?: boolean,
): UseQueryResult<QuestionResponse, unknown> =>
    useBffGet<QuestionResponse>(
        productId ? `/turn-to/questions/${productId}` : null,
        [{ limit, offset, sortOption }],
        [BffQueryKey.TURN_TO_QUESTIONS, productId ?? ''],
        { enabled },
    );
